import {
  earnedAchievementsFromGrants,
  visibleAchievementCount,
} from "@dailywars/core/achievements";
import {
  currentChallengeWeeklyStreak,
  getAllAchievementGrants,
  getPlayer,
  isRegisteredPlayerId,
} from "@dailywars/core/db";
import { createServerFn } from "@tanstack/react-start";

import { setRouteAction } from "#/lib/requestLogger.server";
import { getPlayerPreviewInputSchema } from "#/lib/serverInputSchemas";

export type PlayerPreview = {
  displayName: string;
  gamesCompleted: number;
  goldMedals: number;
  silverMedals: number;
  bronzeMedals: number;
  challengeStars: number;
  challengeWeeklyStreak: number;
  standardDailyStreak: number;
  premiumDailyStreak: number;
  earnedAchievementCount: number;
  totalAchievementCount: number;
};

export const getPlayerPreview = createServerFn({ method: "GET" })
  .validator(getPlayerPreviewInputSchema)
  .handler(async ({ data }): Promise<PlayerPreview | null> => {
    setRouteAction("player_preview");
    if (!isRegisteredPlayerId(data.playerId)) return null;
    const [player, grants] = await Promise.all([
      getPlayer(data.playerId),
      getAllAchievementGrants(data.playerId),
    ]);
    if (!player) return null;
    return {
      displayName: player.displayName,
      gamesCompleted: player.gamesCompleted ?? 0,
      goldMedals: player.goldMedals ?? 0,
      silverMedals: player.silverMedals ?? 0,
      bronzeMedals: player.bronzeMedals ?? 0,
      challengeStars: player.challengeStars ?? 0,
      challengeWeeklyStreak: currentChallengeWeeklyStreak({ player }),
      standardDailyStreak: player.standardDailyStreak ?? 0,
      premiumDailyStreak: player.premiumDailyStreak ?? 0,
      earnedAchievementCount: earnedAchievementsFromGrants(grants).length,
      totalAchievementCount: visibleAchievementCount(),
    };
  });
